import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

const TRUST_PORTAL_REQUEST_ACCESS_VALUES = [
  {
    value: 'open',
    label: 'Open',
  },
  {
    value: 'closed',
    label: 'Closed',
  },
]

export const TrustPortalRequestAccessDropdown = (): JSX.Element => {
  return (
    <FilterDropdown
      filterParam={FilterParam.TRUST_PORTAL_REQUEST_ACCESS}
      filterName={FilterName.TRUST_PORTAL_REQUEST_ACCESS}
      filterValues={TRUST_PORTAL_REQUEST_ACCESS_VALUES}
    />
  )
}
